import gql from 'graphql-tag';

export const GET_LABELS_QUERY = gql`
  query GetLabels {
    loggedIn {
      labels {
        id
        name
      }
    }
  }
`;

export { useGetLabelsQuery } from '../gen/types';
